module.exports = __webpack_public_path__ + "static/media/volume-off.566ec3d6.svg";